import { ATS_CALL_FROM_KEY } from '@/constants/atsCalls';
import { type IAtsCallFromStorage } from '@/types/IAtsCallFromStorage';
import { isRecord } from '@/utils/isRecord';

const isAtsCallFromStorage = (value: unknown): value is IAtsCallFromStorage =>
  isRecord(value) && typeof value.selected === 'string';

/**
 * Читает выбранную линию для исходящего звонка из localStorage.
 * При отсутствии или повреждении записи возвращает `null` — вызывающий код
 * сам решает, чем подставить значение по умолчанию.
 * Это UI-предпочтение менеджера, при логауте оно не очищается: актуальность
 * гарантирует сверка со списком, пришедшим от бэкенда.
 *
 * @returns сохранённая линия либо `null`
 */
export const readSelectedCallFrom = (): string | null => {
  const raw = localStorage.getItem(ATS_CALL_FROM_KEY);

  if (raw === null) {
    return null;
  }

  let parsed: unknown;

  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }

  if (!isAtsCallFromStorage(parsed) || parsed.selected.trim() === '') {
    return null;
  }

  return parsed.selected;
};

/**
 * Сохраняет выбранную линию для исходящего звонка в localStorage.
 *
 * @param selected - идентификатор линии из списка `/call-from`
 */
export const saveSelectedCallFrom = (selected: string): void => {
  const payload: IAtsCallFromStorage = { selected };

  localStorage.setItem(ATS_CALL_FROM_KEY, JSON.stringify(payload));
};
